import React from 'react'
import { IonCol, IonItem, IonLabel, IonRow, IonToggle } from '@ionic/react'
import DateTimePicker from './DateTimePicker/DateTimePicker.component'
import { useTranslation } from 'react-i18next'
import './Calendar.component.css'
import { useDispatch } from 'react-redux'
import { IOptions, IPNNVOption } from '../../common/common.types'

export interface ICalendarProps {
  dataTestID: string
  label?: string
  selectedDate: string | null
  action: (selectedDate: string | null) => void
  showToggle?: boolean
  toggleValue?: number | null
  toggleAction: (toggleValue: number) => void
  isStateAction?: boolean
  disabled?: boolean
  showTimeSection?: boolean
  pnnvOptions?: IOptions
  pnnvValue?: IPNNVOption | null | undefined
  pnnvAction?: (...args: any[]) => any
  pnnvLabel?: string
  pnnvListHeader?: string
  useBothNormalAndPertinent?: boolean
}

const Calendar: React.FC<ICalendarProps> = (props: ICalendarProps) => {
  const {
    dataTestID,
    label,
    selectedDate,
    action,
    showToggle = false,
    toggleAction,
    toggleValue = 0,
    isStateAction,
    disabled,
    showTimeSection = true,
    pnnvOptions = [],
    pnnvValue = undefined,
    pnnvAction = () => () => void 0,
    pnnvLabel = '',
    pnnvListHeader = '',
    useBothNormalAndPertinent = false,
  } = props
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const updatedToggleValue = Boolean(toggleValue)

  const onToggleChange = (value: boolean) => {
    if (value) {
      if (isStateAction) {
        toggleAction(0)
      } else {
        dispatch(toggleAction(0))
      }
      action('')
    } else {
      if (isStateAction) {
        toggleAction(1)
      } else {
        dispatch(toggleAction(1))
      }
      action(null)
    }
  }

  return (
    <>
      <IonRow className='calendar-row'>
        <IonCol size={showToggle ? '7' : '12'} className='ion-no-padding calendar-datetime-col'>
          <DateTimePicker
            dataTestID={dataTestID}
            selectedDateValue={selectedDate}
            action={action}
            label={label || t('common.TimeLastWellKnown')}
            disabled={disabled || toggleValue === 1}
            showTimeSection={showTimeSection}
            pnnvOptions={pnnvOptions}
            pnnvValue={pnnvValue}
            pnnvAction={pnnvAction}
            pnnvLabel={pnnvLabel}
            pnnvListHeader={pnnvListHeader}
            useBothNormalAndPertinent={useBothNormalAndPertinent}
          />
        </IonCol>
        {showToggle && (
          <IonCol size={showToggle ? '5' : ''} className='ion-no-padding calendar-toggle'>
            <IonItem className='toogle-item calendar-toggle'>
              <IonToggle
                className='calendar-toggle'
                checked={updatedToggleValue}
                onClick={() => onToggleChange(updatedToggleValue)}
              />
              <IonLabel className='selected-option calendar-toggle-prefix-width '>{t('common.Unknown')}</IonLabel>
            </IonItem>
          </IonCol>
        )}
      </IonRow>
    </>
  )
}

export default Calendar
